/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import CartAmountTrigger from './triggers/cart-amount-trigger';
import CartNumberOfItemsTrigger from './triggers/cart-number-of-items-trigger';
import CartSpecificProductTrigger from './triggers/cart-specific-product-trigger';
import DateRangeTrigger from './triggers/date-range-trigger';
import FromSpecificPageTrigger from './triggers/from-specific-page-trigger';
import PageVisitTrigger from './triggers/page-visits-trigger';
import SpecificCountryRegionTrigger from './triggers/specific-CountryRegion-trigger';
import SpecificPageTrigger from './triggers/specific-page-trigger';
import WaitOnTimeTrigger from './triggers/wait-on-time-trigger';

type ProactiveChat =
    | typeof DateRangeTrigger
    | typeof SpecificPageTrigger
    | typeof FromSpecificPageTrigger
    | typeof PageVisitTrigger
    | typeof SpecificCountryRegionTrigger
    | typeof CartAmountTrigger
    | typeof CartNumberOfItemsTrigger
    | typeof CartSpecificProductTrigger
    | typeof WaitOnTimeTrigger;

/**
 * List of Proactive Chat Validators in order of validation (first proactive chat that pass validation is triggered, the rest are ommited)
 */
export const ProactiveTriggers: ProactiveChat[] = [
    DateRangeTrigger,
    SpecificPageTrigger,
    FromSpecificPageTrigger,
    PageVisitTrigger,
    SpecificCountryRegionTrigger,
    CartAmountTrigger,
    CartNumberOfItemsTrigger,
    CartSpecificProductTrigger,
    WaitOnTimeTrigger
];
